import { createDataHooks } from '@wix/premium-fed-sdk/test-utils';
export const ResultsLayoutDataHooks = createDataHooks('resultsLayout', 'voucherRow');
//# sourceMappingURL=dataHooks.js.map